/**
 * The dashboard's own addresses, once signed in. The caseload is the root:
 * it is what a clinician opens the dashboard to do, owner or not.
 */
export const ADMIN_PATH = '/admin';
export const SETTINGS_PATH = '/settings';

export type View = 'caseload' | 'administration' | 'settings';

export function pathOf(view: View): string {
  return view === 'administration' ? ADMIN_PATH : view === 'settings' ? SETTINGS_PATH : '/';
}

/**
 * The view an address asks for. Administration only for an owner: anyone else
 * asking for it gets the caseload. Settings is everybody's own.
 */
export function viewAt(path: string, isOwner: boolean): View {
  const clean = path.replace(/\/+$/, '');
  if (clean === SETTINGS_PATH) return 'settings';
  if (clean === ADMIN_PATH && isOwner) return 'administration';
  return 'caseload';
}
